export default __webpack_public_path__ + "static/media/GF.afc9b650.svg";